<template>
  <Block
    id="passport"
    :class="[$platformClass, customExeCenterStyle]"
    type="pageContainer"
  >
    <Header :showLogout="southEstAsiaMode"></Header>
    <List type="passportFunctionList" class="passport-functions">
      <ListItem
        beforeIconType="bindIcon"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        type="functionItem"
        class="passport-function j-bind-account-btn"
        @click="showBindAccountDialog"
        v-if="!southEstAsiaMode && !isDmm && !isHideBindAndSwitch"
        v-touchActive
      >
        <Block tagName="p" type="funtionListItem" class="function-name">
          {{ languages.bind }}
        </Block>
        <i class="gift-icon" v-if="isShowRedDot"></i>
        <i v-if="bindItemRedDot" class="function-red-dot"></i>
      </ListItem>
      <ListItem
        type="functionItem"
        beforeIconType="userIcon"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        class="passport-function j-account-setting-btn"
        v-if="southEstAsiaMode"
        v-touchActive
      >
        <router-link to="/accountSetting" class="link-wrapper">
          <Block tagName="p" type="funtionListItem" class="function-name">
            {{ languages.accountSetting }}
          </Block>
        </router-link>
      </ListItem>
      <ListItem
        type="functionItem"
        class="passport-function j-switch-account-not-sea-btn"
        beforeIconType="userIcon"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        @click="switchAccount"
        v-if="
          !southEstAsiaMode &&
          !isDmm &&
          !isOuterExeClient &&
          !isHideBindAndSwitch
        "
        v-touchActive
      >
        <Block tagName="p" type="funtionListItem" class="function-name">
          {{ languages.switch }}
        </Block>
      </ListItem>
      <ListItem
        type="functionItem"
        beforeIconType="accountFollowIcon"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        class="passport-function j-mcode-btn"
        v-if="hasMigrateFunction && !isDmm"
        v-touchActive
      >
        <router-link to="/accountFollow" class="link-wrapper">
          <Block tagName="p" type="funtionListItem" class="function-name">
            {{ languages.account_yjm }}
          </Block>
        </router-link>
      </ListItem>
      <ListItem
        type="functionItem"
        beforeIconType="ellipsisIcon"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        class="passport-function j-feedback-btn"
        v-if="isShowFeebackPage"
        @click="handleFeedbackGuidePopup"
        v-touchActive
      >
        <Block tagName="p" type="funtionListItem" class="function-name">
          {{ languages.feedback }}
        </Block>
        <i v-if="hasUnreadFeedback" class="new-message"></i>
      </ListItem>
      <ListItem
        type="functionItem"
        class="passport-function j-questionnaire-btn"
        beforeIconType="survey"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        @click="gotoKRSurvey"
        v-if="showKRSurveyEntry"
        v-touchActive
      >
        <Block
          tagName="p"
          type="funtionListItem"
          class="function-name kr-rlwj-survey"
        >
          설문조사
          <span class="gift-icon"></span>
        </Block>
      </ListItem>
      <ListItem
        type="functionItem"
        class="passport-function j-questionnaire-btn"
        beforeIconType="rewardIcon"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        @click="gotoQuesnaire"
        v-if="questionnaireState"
        v-touchActive
      >
        <Block tagName="p" type="funtionListItem" class="function-name">
          {{ languages.questionnaire_btn }}
        </Block>
      </ListItem>
      <ListItem
        type="functionItem"
        beforeIconType="officialPayIcon"
        pointClass="j-official-pay"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        class="passport-function"
        @click="openExePay"
        v-if="isExeUserCenter && !isSteam && !isRoworldSea"
        v-touchActive
      >
        <a class="pay-link" href="javascript:void(0);">
          <Block tagName="p" type="funtionListItem" class="function-name">
            {{ languages.officialPay }}
          </Block>
        </a>
      </ListItem>
      <!-- 20240329 需求人：邓智轩 斗罗大陆H5用户中心协议外跳打开 -->
      <ListItem
        v-if="+gameId === 195"
        type="functionItem"
        beforeIconType="textIcon"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        class="passport-function j-terms-btn"
        @click="openTermsLink"
        v-touchActive
      >
        <a class="terms-link" href="javascript:void(0);">
          <Block tagName="p" type="funtionListItem" class="function-name">
            {{ languages.terms }}
          </Block>
        </a>
      </ListItem>
      <template v-else-if="+gameId === 201">
        <ListItem
          type="functionItem"
          beforeIconType="textIcon"
          leftSpan="0"
          rightSpan="0"
          afterIconType="selectHili"
          class="passport-function"
          @click="openTermsByOuterBrowser('https://honghaco.vn/dieu-khoan')"
          v-touchActive
        >
          <a class="terms-link" href="javascript:void(0);">
            <Block tagName="p" type="funtionListItem" class="function-name">
              {{ languages.termsOfUse }}
            </Block>
          </a>
        </ListItem>
        <ListItem
          type="functionItem"
          beforeIconType="textIcon"
          leftSpan="0"
          rightSpan="0"
          afterIconType="selectHili"
          class="passport-function"
          @click="openTermsByOuterBrowser('https://honghaco.vn/bao-mat')"
          v-touchActive
        >
          <a class="terms-link" href="javascript:void(0);">
            <Block tagName="p" type="funtionListItem" class="function-name">
              {{ languages.privacyPolicy }}
            </Block>
          </a>
        </ListItem>
      </template>

      <ListItem
        v-else
        type="functionItem"
        beforeIconType="textIcon"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        class="passport-function j-terms-btn"
        v-touchActive
      >
        <router-link
          :to="isKrNewPolicyGame ? '/service?type=serviceContract' : '/service'"
          class="link-wrapper"
        >
          <Block tagName="p" type="funtionListItem" class="function-name">
            {{ languages.terms }}
          </Block>
        </router-link>
      </ListItem>
      <ListItem
        v-if="isKrNewPolicyGame"
        type="functionItem"
        beforeIconType="textIcon"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        class="passport-function j-terms-btn"
        v-touchActive
      >
        <router-link to="/service?type=userContract" class="link-wrapper">
          <Block tagName="p" type="funtionListItem" class="function-name">
            {{ languages.privacyPolicy }}
          </Block>
        </router-link>
      </ListItem>
      <!-- 20240910 需求人：张莉 【用户中心】新增风险提示文案 -->
      <!-- 重点游戏覆盖（全部为父游戏）：PNS、蚂蚁军团、K1、巨兽、侏罗纪军团、寻道大千、智诚战纪、叫我大掌柜、斗罗3D、霸业2.0 -->
      <ListItem
        type="functionItem"
        beforeIconType="textIcon"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        class="passport-function j-risk-btn"
        v-touchActive
        @click="popupRiskWindow"
      >
        <div class="link-wrapper">
          <Block tagName="p" type="" class="function-name">
            {{ languages.riskTipTitle }}
          </Block>
        </div>
      </ListItem>

      <ListItem
        type="functionItem"
        class="passport-function j-exchange-gift-btn"
        beforeIconType="fundTermsIcon"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        @click="showFundTermsPage"
        v-if="showFundTerms"
        v-touchActive
      >
        <Block tagName="p" type="funtionListItem" class="function-name">
          資金決済法に基づく表示
        </Block>
      </ListItem>
      <ListItem
        type="functionItem"
        class="passport-function j-exchange-gift-btn"
        beforeIconType="fundTermsIcon"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        @click="showFundTerms2Page"
        v-if="showFundTerms2"
        v-touchActive
      >
        <Block tagName="p" type="funtionListItem" class="function-name">
          特定商取引法に基づく表示
        </Block>
      </ListItem>
      <ListItem
        type="functionItem"
        beforeIconType="tokenIcon"
        pointClass="j-token-login"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        class="passport-function"
        v-if="showTokenLoginBtn"
        v-touchActive
      >
        <router-link to="/tokenLogin" class="link-wrapper">
          <Block tagName="p" type="funtionListItem" class="function-name">
            {{ languages.tokenLogin }}
          </Block>
        </router-link>
      </ListItem>

      <!-- 20240131:dma弹窗入口，由sdk那边控制是否展示 -->
      <ListItem
        type="functionItem"
        beforeIconType="dmaIcon"
        pointClass="j-dma-popup"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        class="passport-function"
        v-if="isShowDmaBtn"
        v-touchActive
        @click="excOpenDmaPopup"
      >
        <Block tagName="p" type="funtionListItem" class="function-name">
          {{ languages.dmaTitle }}
        </Block>
      </ListItem>

      <!-- PNS需要在SDK外跳的用户中心开启领奖页活动入口 -->
      <ListItem
        type="functionItem"
        class="passport-function j-exchange-gift-btn animate-item"
        beforeIconType="rewardIcon"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        @click="openExeGetReward"
        v-if="showGetRewatdBtn"
        v-touchActive
      >
        <a class="getrewatd-link" href="javascript:void(0);">
          <Block tagName="p" type="funtionListItem" class="function-name">
            {{ languages.getReward }}
          </Block>
        </a>
      </ListItem>

      <!--  onestore订阅功能  -->
      <ListItem
        type="functionItem"
        beforeIconType="subscribeIcon"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        class="passport-function"
        v-if="showOneStoreSubscribe"
        v-touchActive
      >
        <router-link to="/onestoreSubscribe" class="link-wrapper">
          <Block tagName="p" type="funtionListItem" class="function-name">
            {{ languages.onestore_subscribe_entrance }}
          </Block>
        </router-link>
      </ListItem>
      <transition-group tag="div" name="item-in">
        <ListItem
          type="functionItem"
          class="passport-function j-exchange-gift-btn animate-item"
          beforeIconType="exchangeIcon"
          leftSpan="0"
          rightSpan="0"
          key="exchangePage"
          afterIconType="selectHili"
          @click="showExchangePage"
          v-if="isShowExchangePage"
          v-touchActive
        >
          <Block tagName="p" type="funtionListItem" class="function-name">
            {{ languages.exchange }}
          </Block>
        </ListItem>
        <ListItem
          type="functionItem"
          class="passport-function animate-item"
          pointClass="j-account-delete-btn"
          beforeIconType="appleDeleteIcon"
          leftSpan="0"
          rightSpan="0"
          key="accountDelete"
          afterIconType="selectHili"
          @click="goAccountDelete"
          v-if="showAccountDelete && canAnimate"
          v-touchActive
        >
          <Block tagName="p" type="funtionListItem" class="function-name">
            {{ languages.apple_deleteaccount }}
          </Block>
        </ListItem>
        <ListItem
          type="functionItem"
          class="passport-function animate-item"
          pointClass="j-h5-pwa-install-btn"
          beforeIconType="shortcutIcon"
          leftSpan="0"
          rightSpan="0"
          key="h5PwaInstallBtn"
          @click="postMessageToH5InstallPwa"
          v-if="showH5PwaInstall"
          v-touchActive
        >
          <Block tagName="p" type="funtionListItem" class="function-name">
            {{ languages.pwsInstall }}
          </Block>
          <i v-if="showH5PwaInstallRedDot" class="function-red-dot"></i>
        </ListItem>
        <template v-if="canAnimate">
          <ListItem
            type="functionItem"
            class="passport-function animate-item"
            afterIconType="selectHili"
            leftSpan="0"
            rightSpan="0"
            @click="
              gotoCustomLink(
                item.link,
                item.openType,
                item.configId,
                item.redDot
              )
            "
            v-for="item in floatSdkParamList"
            v-bind:key="item.name"
            v-touchActive
          >
            <img class="passport-custom-ico" :src="item.ico" />
            <Block tagName="p" type="funtionListItem" class="function-name">
              {{ item.name }}
            </Block>
            <i v-if="item.redDot" class="function-red-dot"></i>
          </ListItem>
        </template>
      </transition-group>
      <ListItem
        type="functionItem"
        beforeIconType="userIcon"
        pointClass="j-exe-switch-account"
        leftSpan="0"
        rightSpan="0"
        afterIconType="selectHili"
        class="passport-function exe-switch-account-icon"
        @click="openExeSwitchAccount"
        v-if="showExeSwitchAccount"
        v-touchActive
      >
        <a class="pay-link" href="javascript:void(0);">
          <Block tagName="p" type="funtionListItem" class="function-name">
            {{ languages.changeAccount }}
          </Block>
        </a>
      </ListItem>
    </List>
    <transition name="fade">
      <Dialog
        @bindFail="accountOpsFail"
        @feedbackPage="feedbackPage"
        v-show="showDialog"
      ></Dialog>
    </transition>
    <transition name="fade">
      <Tost v-show="showTost"></Tost>
    </transition>
    <PopupWindow
      @onCancel="showPopup = false"
      @onConfirm="showPopup = false"
      type="tips"
      v-if="showPopup"
      :languages="languages"
      :content="errTips"
    ></PopupWindow>
    <PopupWindow
      type="confirm"
      @onCancel="closeWebview"
      @onConfirm="closeWebview"
      v-if="loginFail"
      :languages="languages"
      :content="loginFailTips"
    ></PopupWindow>
    <PopupWindow
      type="confirm"
      @onCancel="hideSwitchTips"
      @onConfirm="showSwitchAccountDialog"
      v-if="showSwitchTipsPopup"
      :languages="languages"
      :content="swtichTips"
      :tips="languages.bindTps"
    ></PopupWindow>
    <PopupWindow
      type="confirm"
      @onCancel="showFailTips = false"
      @onConfirm="showFailTips = false"
      v-if="showFailTips"
      :languages="languages"
      :content="accoutOpsTips"
    ></PopupWindow>
    <!--工单外跳浏览器弹窗-->
    <PopupWindow
      type="confirm"
      @onCancel="showFeedbackPopup = false"
      @onConfirm="showFeebackPage"
      v-if="isShowFeedbackTips && showFeedbackPopup"
      :languages="languages"
      :content="languages.feedbackTips"
    ></PopupWindow>
    <!--客服公告弹窗-->
    <NoticePopup
      v-if="isNoticePopup"
      @closePopup="isNoticePopup = false"
      @openService="checkShowModsPopup"
      :languages="languages"
      :noticeList="noticeList"
    ></NoticePopup>
    <!--版主下沉弹窗-->
    <transition name="fade">
      <ModsGuide
        v-if="isModsPopup"
        @openMods="openMods"
        @openService="feedbackPage"
        @closePopup="isModsPopup = false"
        :languages="languages"
      ></ModsGuide>
    </transition>
    <transition name="fade">
      <div
        style="position: fixed; width: 100%; height: 100%; top: 0; left: 0"
        v-if="dmaPopupState"
      >
        <div class="dma-popup">
          <dma-popup
            :isFromUserCenter="true"
            :defaultSelect="dmaDefaultSelect"
            @closePopup="closeDmaPopup"
            @submitDma="submitDma"
          ></dma-popup>
        </div>
      </div>
    </transition>
  </Block>
</template>
<style lang="scss">
@import '../../assets/scss/base.scss';
@import '../../assets/scss/passport.scss';
@import '../../assets/scss/platform-base.scss';
@import '../../assets/scss/platform-passport.scss';
.kr-rlwj-survey {
  position: relative;
  .gift-icon {
    display: block;
    position: absolute;
    right: 10px;
    top: 0;
    width: 52px;
    height: 95px;
    background: url('../../assets/image/passport/gift.png') no-repeat center
      center;
    background-size: contain;
  }
}
</style>
<script>
import Dialog from '../../components/passport/Dialog';
import Tost from '../../components/Tost';
import Header from '../../components/passport/Header';
import {
  SHOW_TIPS_MSG,
  BINDING_DIALOG,
  SHOW_DIALOG,
  SWICH_ACCOUNT_DIALOG
} from '../../store/dialog';
import {
  LOGIN,
  PAGE_INIT,
  GET_BIND_REWARD,
  CHECK_BIND_REWARD,
  CHECK_OPEN_DELETE,
  CHECK_FLOAT_SDK_PARAM,
  CLEAR_RED_POINT,
  GET_USER_SUB,
  GET_CAN_DEBIND_TYPE,
  GET_NOTICE_POPUP,
  GET_MODS_POPUP,
  SEND_SHOW_NOTICE_RECORD,
  UPDATE_DMA_SELECT
} from '../../store/account';
import globalConfig from '../../utiles/globalConfig';
import bridge from '../../utiles/bridge';
import { SOUTHEST_ASIA_MODE, FEEKBACK_URL } from '../../utiles';
import {
  GET_CONFIG,
  GET_SERIAL_EXCHANGE,
  GET_GAME
} from '../../store/passport';
import { getHrefParam, getJSON } from '../../store/ultile';
import { LOAD_USER_INFO } from '../../store/passport/accountSetting';
import { LOAD_SERVICE_STATUS } from '../../store/services';
import { mapActions } from 'vuex';
import md5 from 'md5';
import { feedbackPopupWhiteList } from '../../utiles/globalConfig';
import { CHECK_IP_LOCATION } from '../../store/ipCheck';
import { GET_EXE_CLIENT_PAY } from '../../store/passport/index';
import { PASSPORT_HOST } from '../../store/ultile';
import { HTTPS } from '../../store/web/h5';
import * as exesdk from '../../utiles/exeSdk';
import ModsGuide from '@components/passport/ModsGuide.vue';
import NoticePopup from '@components/passport/NoticePopup.vue';
import DmaPopup from '@components/dma/dmaPopup.vue';
import { commonEmitUpload } from '../../plugins/AnalyzePoint';
import {
  getGlobalGetGotoLink,
  getGlobalGetLinkParams
} from '@utiles/globalGetLink';
import customStyleMixins from '@mixins/customStyle';
let packageName = globalConfig.getHrefParam('packageName');
let zone = globalConfig.getHrefParam('zone');
let devicePlate = globalConfig.getHrefParam('devicePlate');
let appLanguage = globalConfig.getHrefParam('appLanguage');
let packageVersion = globalConfig.getHrefParam('packageVersion');
let CacheToken = globalConfig.getHrefParam('CacheToken');
const OPEN_BROSWER_METHOD = 'openBrowser';
const OPEN_WEBVIEW_METHOD = 'openWebView';
const USER_MODE = globalConfig.getHrefParam('userMode');
const SHOW_DELETE_ACCOUNT_BTN =
  globalConfig.getHrefParam('showDeleteAccountBtn') === '1';
const HAS_SERVER_ID = globalConfig.getHrefParam('serverId') !== '';
const IS_IOS = devicePlate == 'ios';
const IS_FROM_ELECTRON =
  /Electron/.test(window.navigator.userAgent) ||
  /Client/.test(globalConfig.getHrefParam('from'));
const IS_REVIEW = parseInt(CacheToken, 10) || 0;
let gameId = getHrefParam('gameId');
let from = getHrefParam('from');
let isBrowser = getHrefParam('isBrowser');
let configStore = localStorage.getItem('functionConfig');
const mainHost = globalConfig.getMainHost();
if (configStore) {
  configStore = JSON.parse(configStore)[gameId];
}
let deleteAccount = globalConfig.getHrefParam('deleteAccount');

// 需要显示OTP/UID Token登录的游戏列表
const EXE_GAME_LIST = [
  191, 284, 251, 175, 255, 247, 209, 231, 213, 263, 269, 272, 274, 225, 227,
  211, 288, 261, 221, 195, 201, 215, 321, 295, 306, 322, 324, 331, 285, 337,
  333, 314, 294, 310, 361, 365, 370, 355, 354, 349, 389, 390, 382, 424, 410,
  429, 454, 440
];
// 需要在微端的用户中心开启领奖页入口
const EXE_GET_REWARD_GAME_LIST = [191, 225, 227];
export const KR_NEW_POLICY_GAME = [211, 227];

// 审核模式不开启自定义用户中心的游戏
const CACHE_TOKEN_HIDE_BTN_GAME = [213];
const isDomainBlancozone = () => {
  return globalConfig.getMainHost() === 'blancozone.com';
};
export const isKrNewPolicyGame = () => {
  return KR_NEW_POLICY_GAME.includes(+gameId) && isDomainBlancozone();
};

export default {
  name: 'passportNAme',
  mixins: [customStyleMixins],
  computed: {
    unBindState() {
      return this.$store.state.passport.unBindState;
    },
    isH5() {
      return globalConfig.getHrefParam('h5') === '1';
    },
    showDialog() {
      return this.$store.state.dialog.showDialog;
    },
    showTost() {
      return this.$store.state.dialog.tostShowStatus;
    },
    userName() {
      return (
        this.$store.state.account.userName ||
        globalConfig.getHrefParam('userName') ||
        ''
      );
    },
    logined() {
      return this.$store.state.account.logined;
    },
    loginPath() {
      return this.$store.state.account.loginPath;
    },
    languages() {
      return this.$store.state.passport.languages;
    },
    displayName() {
      return this.$store.state.account.displayName;
    },
    userId() {
      return this.$store.state.account.userId;
    },
    isBindThird() {
      return this.$store.state.account.isBindThird;
    },
    hasMigrateFunction() {
      let supportBySDK =
        this.$store.state.account.bindSupportArr.includes('mg');
      let supportByBackEnd =
        this.$store.state.passport.hasMigrateFunction ||
        (configStore && configStore.hasMigrateFunction) ||
        globalConfig.getHrefParam('ismgcode') === '1';
      let notSupportByPackage =
        ['com.blancozone.wtb', 'com.jp.devil', 'com.jp.devil.ios'].includes(
          packageName
        ) ||
        (packageName === 'com.global.kingdom.ios' && CacheToken == 1);
      return !notSupportByPackage && (supportBySDK || supportByBackEnd);
    },
    // 是否开启序号兑换功能
    isShowExchangePage() {
      // 2021-10-21 石学谦：ios提审时不开启兑换页
      if (globalConfig.getHrefParam('CacheToken') == '1') {
        return false;
      }
      return this.$store.getters.getExchangeState;
    },
    // 是否开启外跳浏览器权限弹窗
    isShowFeedbackTips() {
      // 游戏包体:packageName, 地区：zone, 设备：devicePlate, 语言：appLanguage
      return feedbackPopupWhiteList.some(
        v =>
          v.packageName === packageName &&
          v.zone === zone &&
          v.devicePlate === devicePlate &&
          v.appLanguage === appLanguage
      );
    },
    // 功能名称显示逻辑： 資金決済法に基づく表示
    showFundTerms() {
      // 魔王、鬼语、拳皇显示，斗罗为日语才显示
      const lang =
        globalConfig.getHrefParam('language') ||
        globalConfig.getHrefParam('appLanguage');

      // 2022.03.02 末日喧嚣全球版根据日本ip显示协议入口
      // 2023.09.07 K1全球版根据日本ip显示协议入口
      return (
        (+gameId === 159 && lang === 'ja-JP') ||
        (+gameId === 191 && this.$store.state.ipCheck.ISO_TWO_CODE === 'JP') ||
        (+gameId === 285 && this.$store.state.ipCheck.ISO_TWO_CODE === 'JP')
      );
    },
    // 功能名称显示逻辑： 特定商取引法に基づく表示
    showFundTerms2() {
      // 2023.09.07 K1全球版根据日本ip显示协议入口
      return +gameId === 285 && this.$store.state.ipCheck.ISO_TWO_CODE === 'JP';
    },
    isKR() {
      const country = getHrefParam('zone');
      return country === 'KOR' || country === 'KR' || country === 'ko-KR';
    },
    showKRSurveyEntry() {
      let surveyEdnTime = new Date('2020/06/22 00:00').getTime();
      let now = new Date().getTime();
      const shouldSHow = now < surveyEdnTime;
      return gameId === '179' && shouldSHow;
    },
    isShowFunctionRedDot() {
      return gameId == 191;
    },
    showOneStoreSubscribe() {
      // 韩国末日喧嚣oneStore包才显示
      return (
        gameId === '227' &&
        globalConfig.getHrefParam('devicePlate') === 'android' &&
        globalConfig.getHrefParam('publishPlatForm') === 'oneStore'
      );
    },
    // 曹超需求：为android且当链接参数customTag=1，隐藏第三方登录与绑定功能
    isHideBindAndSwitch() {
      return (
        globalConfig.getHrefParam('devicePlate') == 'android' &&
        globalConfig.getHrefParam('customTag') == '1'
      );
    },
    isShowDmaBtn() {
      return this.$store.state.account.dmaEnterBtn;
    },
    useDmaPopup() {
      return this.$store.state.account.useDmaPopup;
    },
    dmaDefaultSelect() {
      return this.$store.state.account.dmaSelect;
    },
    bindItemRedDot() {
      let isBindThird = false;
      for (let bindType of this.$store.state.account.bindSupportArr) {
        if (this.$store.state.account[bindType]?.status == 1) {
          isBindThird = true;
          break;
        }
      }
      // 游戏为游客模式+当前账号为游客账号+未绑定任何第三方社交账号
      return (
        !this.southEstAsiaMode &&
        this.$store.state.accountSetting.originUserType == 4 &&
        !isBindThird
      );
    },
    showAccountDelete() {
      // iOS送审模式默认开启
      if (devicePlate == 'ios' && IS_REVIEW) {
        return true;
      }
      // 其他是否开启读接口
      return this.$store.state.passport.hasAccountDelete;
    }
  },
  beforeCreate() {
    globalConfig.storeEntryParams();
    bridge.onReady(() => {
      // sdk 触发准备事件    不应该弄掉这一行！！！ 确保sdk 已经往前端注入方法，否则调用下面可能会报错。
      this.$store
        .dispatch(PAGE_INIT)
        .then(loginPath => {
          this.$store
            .dispatch(LOGIN, loginPath)
            .then(({ logined, errmsg, data }) => {
              if (!logined) {
                this.showLoginFailWdinow(errmsg);
              } else {
                this.$store.dispatch(CHECK_IP_LOCATION);
                this.$store.dispatch(LOAD_USER_INFO, { errmsg });
                this.$store.dispatch(GET_CONFIG);
                this.$store.dispatch(GET_GAME);
                // 检查是否绑定领奖
                var gameId = globalConfig.getHrefParam('gameId');
                var serverId = globalConfig.getHrefParam('serverId');
                var loginAccount = globalConfig.getHrefParam('loginAccount');
                var devicePlate = globalConfig.getHrefParam('devicePlate');
                var roleId = globalConfig.getHrefParam('roleId');
                let language =
                  globalConfig.getHrefParam('appLanguage') ||
                  globalConfig.getHrefParam('language');
                this.getBindReward({
                  gameId,
                  loginAccount,
                  devicePlate,
                  roleId
                });
                let promiseList = [
                  this.$store.dispatch(GET_SERIAL_EXCHANGE),
                  this.getFloatSdkParam({ gameId, devicePlate, language }),
                  this.getNoticePopup(),
                  this.getModsPopup()
                ];
                Promise.all(promiseList)
                  .then(res => {
                    this.canAnimate = true;
                  })
                  .catch(() => {
                    this.canAnimate = true;
                  });
                this.checkVisitorType(errmsg, data);
              }
              this.getUnreadFeedback();
              this.$store.dispatch(LOAD_SERVICE_STATUS);
            });
        })
        .catch(err => {
          let errMsg = err.message;
          this.errTips = errMsg;
          this.showPopup = true;
        });
    });
  },
  created() {
    this.registerReloadWithToken();
    if (
      globalConfig.getHrefParam('packageName') == 'com.global.ztmslg.pc' ||
      globalConfig.getHrefParam('packageName') ==
        'com.blancozone.ztmslgkr.pc' ||
      (this.isH5 &&
        globalConfig.getHrefParam('websdk') == '1' &&
        (+gameId == 191 || +gameId == 227))
    ) {
      let surveyStartTime = new Date('2022/11/20 18:00').getTime();
      let surveyEndTime = new Date('2022/11/28 23:59').getTime();
      let now = new Date().getTime();
      this.questionnaireState = now < surveyEndTime && now > surveyStartTime;
    }
    let devicePlate = globalConfig.getHrefParam('devicePlate');
    let language =
      globalConfig.getHrefParam('appLanguage') ||
      globalConfig.getHrefParam('language');
    this.$isOmni && this.initLandscapeWidthFit();
  },
  mounted() {
    this.initElectron();
    // 2022.11.11 邓智轩：PNS目前需要强推绑定第三方账号功能，需要通用配置链接参数直接弹出绑定功能，引导玩家去绑定。
    if (+globalConfig.getHrefParam('showBindDialog') === 1) {
      this.showBindAccountDialog();
    }
    // dana渠道处理：
    // 这里就不判断是不是dana小程序环境了globalConfig.isDanaMiniProgram()，因为这个自动跳转具备通用性
    // 如果打开的中户中心带有toAccountUpgrade=1参数，跳转到账号升级页面，账号升级在账号设置里面，先到账号设置
    if (+globalConfig.getHrefParam('toAccountUpgrade') === 1) {
      this.$router.push({ path: '/accountSetting' });
    }
  },
  data() {
    let isH5UserCenter = globalConfig.getHrefParam('h5') === '1'; // 是否是H5打开
    let isExeUserCenter =
      (from === 'pnsClient' || from === 'exeClient') && +gameId != 386; // 是否是微端打开
    let isOuterExeClient = isBrowser == 1; // 是否是微端外跳浏览器打开
    return {
      uidGame: +gameId == 215,
      name: 'passport',
      sex: 'male',
      southEstAsiaMode: USER_MODE == SOUTHEST_ASIA_MODE,
      isReview: parseInt(getHrefParam('CacheToken'), 10) || 0, // 1 审核模式隐藏账号绑定按钮，0非审核模式显示绑定按钮（默认）
      isShowRedDot: 0, // 0 不显示，1显示
      krTips: 0,
      popupType: 'tips',
      errTips: '',
      showPopup: false,
      loginFailTips: '',
      loginFail: false,
      swtichTips: '',
      showSwitchTipsPopup: false,
      showFailTips: false,
      accoutOpsTips: '',
      questionnaireState: false,
      hasUnreadFeedback: false,
      serverList: [],
      floatSdkParamList: [],
      canAnimate: false,
      // 2021.07.14 DMM平台识别，因要使用DMM账号，所以屏蔽绑定、切换、引继码功能
      isDmm: globalConfig.getHrefParam('publishPlatForm') === 'dmm',
      // 2021.08.06 临时关闭荣耀大天使的工单
      isShowFeebackPage: +gameId !== 261,
      showFeedbackPopup: false,
      isVisitorFromAPi: false, //由接口获取是否游客登录
      gameId: gameId || '',
      hasSub: false, // 账号删除前是否有订阅
      isExeUserCenter,
      isOuterExeClient, // 是否是微端外跳浏览器打开
      showTokenLoginBtn: (() => {
        // 送审模式下不显示
        const CacheToken = +globalConfig.getHrefParam('CacheToken');
        // 浏览器或者微端打开用户中心都不显示令牌登录入口
        // 2023.1.5 需求人:邓智轩 H5用户中心也不显示令牌生成入口
        if (isExeUserCenter || isOuterExeClient || isH5UserCenter) {
          return false;
        }
        return ~EXE_GAME_LIST.indexOf(+gameId) && CacheToken !== 1;
      })(),
      showGetRewatdBtn: (() => {
        //只在微端游戏里面的用户中心显示领奖页入口
        // 本地开发中先注释方便调试，上线前要打开下面3行
        if (!isOuterExeClient) {
          return false;
        }
        return ~EXE_GET_REWARD_GAME_LIST.indexOf(+gameId);
      })(),
      dmaPopupState: false, //dma弹窗状态
      isKrNewPolicyGame: isKrNewPolicyGame(),
      openNoticePopup: false, // 是否开启客服公告弹框
      isNoticePopup: false, // 客服公告弹框
      hasShowedNoticePopup: false, // 是否弹过，弹过一次之后不再弹，刷新页面重新请求接口
      openModsPopup: false, // 是否开启版主下沉弹框
      isModsPopup: false, // 版主下沉弹框
      noticeList: [], // 公告列表
      showH5PwaInstall: +globalConfig.getHrefParam('showPwaInstall') === 1, // 是否显示H5 PWA安装按钮
      showH5PwaInstallRedDot:
        +window.localStorage?.getItem?.('showH5PwaInstallRedDot') !== 1, // H5 PWA安装按钮红点
      isSteam: +globalConfig.getHrefParam('isSteam') === 1,
      isRoworldSea: +gameId === 456
    };
  },
  methods: {
    ...mapActions(['getWorkList', 'getServerList']),
    // （智轩）精灵圣殿特殊处理：由于合作商还没搞定iframe嵌套的问题，先紧急改外跳浏览器打开吧
    openTermsByOuterBrowser(url) {
      const devicePlate = globalConfig.getHrefParam('devicePlate');
      const isIOS = devicePlate === 'ios';
      bridge.callSdkMethod(OPEN_BROSWER_METHOD, {
        url,
        loginDir: isIOS ? '0' : 0,
        appendParams: isIOS ? '0' : 0
      });
    },
    postMessageToH5InstallPwa() {
      this.showH5PwaInstallRedDot = false;
      window.localStorage?.setItem?.('showH5PwaInstallRedDot', 1);
      window.parent.postMessage(
        {
          method: 'installPwa'
        },
        '*'
      );
      window.passportDataLayer.push({
        eventName: 'click_button',
        eventValue: '',
        eventType: 'addToPwa',
        eventReason: ''
      });
    },
    initElectron() {
      if (this.isExeUserCenter && !this.isOuterExeClient) {
        window.addEventListener('contextmenu', e => {
          e.preventDefault();
          exesdk.sendToIPC('show-context-menu');
        });
        exesdk.onIPC('context-menu-command', (e, command) => {
          history.back();
        });
        exesdk.onIPC('pageForward', (e, command) => {
          history.forward();
        });
        exesdk.onIPC('pageBack', (e, command) => {
          history.back();
        });
      }
    },
    // 这个是用来微端给浏览器获取登录态的
    getExeWebsiteLoginSign(link) {
      const token = globalConfig.getHrefParam('token');
      const cid = globalConfig.getHrefParam('cid');
      const scid = globalConfig.getHrefParam('scid');
      const date = new Date();
      const timestamp = date.getTime();
      const secretKey = '7djs$ss*^shdztmslg@37global.com';
      const sign = md5(token + timestamp + secretKey);
      return `${HTTPS}${PASSPORT_HOST}${GET_EXE_CLIENT_PAY}?token=${token}&gameId=${
        this.gameId
      }&cid=${cid}&scid=${scid}&timestamp=${timestamp}&to=forward&sign=${sign}&forward=${encodeURIComponent(
        link
      )}`;
    },
    async openExePay() {
      const pnsBrowserPayUrl = `https://pay.${mainHost}/platform/officialStore.html`;
      const browserPayUrl = `https://pay.${mainHost}`;
      const realBrowserPayUrl = getGlobalGetGotoLink({
        link: `${
          this.gameId == 191 || this.gameId == 225 || this.gameId == 227
            ? pnsBrowserPayUrl
            : browserPayUrl
        }?gameId=${
          this.gameId
        }&cid=pc&scid=pcuc&appLanguage=${globalConfig.getHrefParam(
          'appLanguage'
        )}&language=${globalConfig.getHrefParam(
          'language'
        )}&server_id=${globalConfig.getHrefParam(
          'server_id'
        )}&serverId=${globalConfig.getHrefParam(
          'serverId'
        )}&roleId=${globalConfig.getHrefParam(
          'roleId'
        )}&roleName=${globalConfig.getHrefParam('roleName')}`
      });
      // 这个是用来给浏览器获取登录态的
      this.isOuterExeClient
        ? window.open(realBrowserPayUrl, '_blank') // 微端外跳了浏览器打开
        : exesdk.openNewWindow(this.getExeWebsiteLoginSign(realBrowserPayUrl)); // 微端内打开
    },
    async openExeGetReward() {
      const rewardLink = {
        191: `//gevents.${mainHost}/pnspcgift/indexm.html`,
        225: `//gevents.${mainHost}/pnspcgift/indexm.html`,
        227: `//gevents.${mainHost}/pnspcgift/indexm.html`
      };
      const realRewardUrl = getGlobalGetGotoLink({
        link: `${rewardLink[+this.gameId]}?gameId=${
          this.gameId
        }&cid=pc&scid=pcuc&appLanguage=${globalConfig.getHrefParam(
          'appLanguage'
        )}&language=${globalConfig.getHrefParam(
          'language'
        )}&server_id=${globalConfig.getHrefParam(
          'server_id'
        )}&serverId=${globalConfig.getHrefParam(
          'serverId'
        )}&roleId=${globalConfig.getHrefParam(
          'roleId'
        )}&roleName=${globalConfig.getHrefParam('roleName')}`
      });
      // 这个是用来给浏览器获取登录态的
      this.isOuterExeClient
        ? window.open(realRewardUrl, '_blank') // 微端外跳了浏览器打开
        : exesdk.openNewWindow(this.getExeWebsiteLoginSign(realRewardUrl)); // 微端内打开
    },
    // 账号删除跳转至客服中心
    jumpToService() {
      // 跳转链接拼接规则，具体数据来自【新大麦-客户系统-智能工单】
      const workTempIdMap = {
        37: [
          191, 221, 225, 284, 227, 355, 354, 285, 342, 175, 346, 288, 263, 328,
          327, 326, 295, 324, 322, 306, 269, 331, 197, 299, 341, 316, 217, 286,
          364, 358, 350, 321, 310, 307, 291, 289, 247, 280, 187, 171, 161
        ],
        25: [333, 314, 361],
        13: [247]
      };
      const workTempId = Object.keys(workTempIdMap).find(key =>
        workTempIdMap[key].includes(+this.gameId)
      );
      if (workTempId) {
        window.location.href = getGlobalGetGotoLink({
          link: `https://gabres.${mainHost}/platform/webOfficialSupport.html?gameId=${this.gameId}#/worktemp?workTempId=${workTempId}&source=passport`
        });
      } else {
        window.location.href = getGlobalGetGotoLink({
          link: `https://gabres.${mainHost}/platform/webOfficialSupport.html?gameId=${this.gameId}`
        });
      }
    },
    goAccountDelete() {
      this.$router.push({ path: '/accountDelete' });
    },
    getUnreadFeedback() {
      this.getWorkList()
        .then(res => {
          if (res.result && +res.result === 1) {
            // 如果工单列表中存在某项有未读消息数，则展示用户中心入口的红点
            this.hasUnreadFeedback = res.data?.LIST?.some(
              item => +item?.UNREAD_COUNT > 0
            );
          } else {
            this.hasUnreadFeedback = false;
          }
        })
        .catch(err => {
          console.error(err);
          this.hasUnreadFeedback = false;
        });
    },
    gotoQuesnaire() {
      let queryArr = [
        'loginAccount',
        'devicePlate',
        'gameId',
        'serverId',
        'roleId',
        'roleName',
        'log',
        'appLanguage'
      ];
      let queryStr = queryArr
        .map(item => {
          let str = getHrefParam(item);
          return `${item === 'devicePlate' ? 'plat' : item}=${str}`;
        })
        .join('&');
      let aid = 'ztmslgwj04';
      // 下面的是特殊地址，之后再加改回`https://gevents.${mainHost}/survey/index.html?aid=${aid}&${queryStr}`，
      // 不然有锅自己背啦
      // window.location.href = `https://gevents.${mainHost}/surveykd/index.html?aid=${aid}&${queryStr}`;
      window.location.href = getGlobalGetGotoLink({
        link: `https://gevents.${mainHost}/survey/index.html?aid=${aid}&${queryStr}`
      });
    },
    showLoginFailWdinow(errmsg) {
      this.loginFail = true;
      this.loginFailTips = errmsg;
    },
    closeWebview() {
      this.loginFail = false;
      bridge.callSdkMethod('closeWebview', {}, res => {});
    },
    accountOpsFail(messae) {
      this.accoutOpsTips = messae;
      this.showFailTips = true;
    },
    gotoKRSurvey() {
      let queryArr = [
        'loginAccount',
        'devicePlate',
        'gameId',
        'serverId',
        'roleId',
        'roleName',
        'log',
        'appLanguage'
      ];
      let queryStr = queryArr
        .map(item => {
          let str = getHrefParam(item);
          return `${item === 'devicePlate' ? 'plat' : item}=${str}`;
        })
        .join('&');
      window.location.href = getGlobalGetGotoLink({
        link: `https://gevents.${mainHost}/survey/index.html?aid=zywj1&${queryStr}`
      });
    },
    initServerList(gameId) {
      this.getServerList(gameId).then(({ res }) => {
        if (res.result === 1) {
          this.serverList = res.data;
        }
      });
    },
    checkVisitorType(errmsg, data) {
      let userType = data.ORIGIN_USER_TYPE || '';
      if (!errmsg && +userType === 4) {
        this.isVisitorFromAPi = true;
      }
    },
    getBindReward({ gameId, loginAccount, devicePlate, roleId }) {
      if (gameId && loginAccount && devicePlate && roleId) {
        this.$store.dispatch(CHECK_BIND_REWARD).then(
          res => {
            // 是否启用绑定领奖 0不启用 1启用
            var allowBind = this.$store.state.account.isAllowBindState;
            // 是否已经领取绑定领奖奖励 1已领取 0未领取
            var isBindReward = this.$store.state.account.isBindRewardState;
            if (allowBind) {
              this.isShowRedDot = isBindReward;
            }
            // 是否已绑定，已绑定&&未领取奖励 则直接发奖
            var isBindAccount = this.$store.state.account.binded;
            if (isBindAccount && !isBindReward) {
              /*
                需求：绑定领奖接口调用下架
                时间：2022/03/14
                需求方：安韶
                需求背景：当前全球平台用户中心绑定领奖接口依托SDK悬浮窗功能配置，且当前没有配置相关领奖，同时绑定领奖和悬浮窗功能应该解藕，暂时下架绑定领奖接口调用。

                this.$store.dispatch(GET_BIND_REWARD);
             */
            }
          },
          res => {}
        );
      }
    },
    showExchangePage() {
      let queryArr = [
        'loginAccount',
        'devicePlate',
        'gameId',
        'serverId',
        'roleId',
        'roleName',
        'log',
        'appLanguage'
      ];
      let queryStr = queryArr
        .map(item => {
          let str = getHrefParam(item);
          return `${item === 'devicePlate' ? 'plat' : item}=${str}`;
        })
        .join('&');
      let href = getGlobalGetGotoLink({
        link:
          `https://gevents.${mainHost}/globalexchange/indexm.html?` + queryStr
      });
      if (this.isExeUserCenter && !this.isOuterExeClient) {
        exesdk.openNewWindow(this.getExeWebsiteLoginSign(href));
      } else {
        window.location.href = href;
      }
    },
    // 資金決済法に基づく表示
    showFundTermsPage() {
      const termsName1 = {
        159: 'dlzj',
        191: 'ztmslgzjjsf',
        285: 'k1zj' // k1
      };
      window.location.href = `https://gpassport.${mainHost}/center/JpServicePrivicy/customize?keyWord=${termsName1[gameId]}`;
    },
    // 特定商取引法に基づく表示
    showFundTerms2Page() {
      const termsName2 = {
        285: 'k1quyin' // k1
      };
      window.location.href = `https://gpassport.${mainHost}/center/JpServicePrivicy/customize?keyWord=${termsName2[gameId]}`;
    },
    // 优先级：客服公告 > 版主下沉 > 跳工单前权限提示弹窗
    handleFeedbackGuidePopup() {
      this.checkShowNoticePopup();
    },
    checkShowNoticePopup() {
      if (this.openNoticePopup && !this.hasShowedNoticePopup) {
        this.isNoticePopup = true;
        this.hasShowedNoticePopup = true;
        commonEmitUpload('show-notice-guide-popup', {
          event: 'show-notice-guide-popup',
          type: 'click',
          pageName: 'home-page'
        });
        this.sendShowNoticeRecord();
      } else {
        this.checkShowModsPopup();
      }
    },
    checkShowModsPopup() {
      if (this.openModsPopup) {
        this.isModsPopup = true;
        commonEmitUpload('show-mods-guide-popup', {
          event: 'show-mods-guide-popup',
          type: 'click',
          pageName: 'home-page'
        });
      } else {
        this.feedbackPage();
      }
    },
    feedbackPage() {
      if (this.isShowFeedbackTips) {
        this.showFeedbackPopup = true;
        return;
      }
      this.showFeebackPage();
    },
    showFeebackPage() {
      let realPage = FEEKBACK_URL;
      if (globalConfig.getHrefParam('websdk') === '1') {
        realPage = `https://gabres.${mainHost}/platform/webSupport.html`;
      }
      let targetPage = {
        215: `https://${globalConfig.getUidGameHost(
          gameId
        )}/platform/webSupport.html?uid=${this.$store.state.account.userId}`,
        229: `https://gabres.${mainHost}/platform/webSupport.html?uid=${this.$store.state.account.userId}`
      };
      if (targetPage[gameId]) {
        realPage = targetPage[gameId];
      }

      bridge.callSdkMethod(OPEN_BROSWER_METHOD, {
        url: getGlobalGetGotoLink({ link: realPage }),
        loginDir: 1,
        appendParams: 1
      });
    },
    openTermsLink() {
      let realPage = `https://gpassport.slfuntap.com/center/servicePrivacy/privacy?gameId=195`;
      bridge.callSdkMethod(OPEN_BROSWER_METHOD, {
        url: realPage,
        loginDir: 1,
        appendParams: 1
      });
    },
    showSwitchAccountDialog() {
      this.hideSwitchTips();
      this.$store.dispatch(SHOW_DIALOG, SWICH_ACCOUNT_DIALOG);
    },
    showBindAccountDialog() {
      this.unBindState &&
        !this.isH5 &&
        this.$store.dispatch(GET_CAN_DEBIND_TYPE, {
          gameId: this.gameId || '',
          packageName: globalConfig.getHrefParam('packageName') || '',
          devicePlate: globalConfig.getHrefParam('devicePlate') || '',
          androidid: globalConfig.getHrefParam('androidid') || '',
          idfa: globalConfig.getHrefParam('idfa') || '',
          gpid: globalConfig.getHrefParam('gpid') || ''
        });
      this.$store.dispatch(SHOW_DIALOG, BINDING_DIALOG);
    },
    switchAccount() {
      //  if(/[a-zA-Z]+\:\d+/.test(this.displayName)){
      //     this.showSwitchTips();
      //  }else{
      //     this.showBindAccountDialog();
      //  }

      if (this.isBindThird) {
        this.showSwitchAccountDialog();
      } else {
        this.showSwitchTips();
      }
    },
    hideSwitchTips() {
      this.showSwitchTipsPopup = false;
      window.setHasGlobalDialog(false);
    },
    showSwitchTips() {
      this.showSwitchTipsPopup = true;
      this.swtichTips = this.languages.guestSwitchTips;
      window.setHasGlobalDialog(true);
      window.globalHideDialogCb = this.hideSwitchTips;
      // this.$store.dispatch(SHOW_TIPS_MSG, {
      //   message: this.languages.guestSwitchTips,
      //   tipsConfirmCallback: SWITCH_ACCOUNT
      // });
    },
    getFloatSdkParam({ gameId, devicePlate, language }) {
      return new Promise(resolve => {
        if (gameId && devicePlate) {
          this.$store.dispatch(CHECK_FLOAT_SDK_PARAM).then(
            res => {
              const function_lists = res?.data?.function_lists;
              function_lists?.forEach(element => {
                let functionTypeCheck =
                  element.FUNCTION_TYPE === 'custom_user_center';
                if (
                  functionTypeCheck &&
                  (!~CACHE_TOKEN_HIDE_BTN_GAME.indexOf(+gameId) ||
                    (!IS_REVIEW && ~CACHE_TOKEN_HIDE_BTN_GAME.indexOf(+gameId)))
                ) {
                  let functionLangList = element?.FUNCTION_LANG_NAME;
                  let functionItem = {
                    name:
                      functionLangList[language] ||
                      element?.FUNCTION_NAME ||
                      functionLangList[Object.keys(functionLangList)[0]],
                    link: element?.FORWARD_LINK,
                    openType: element?.FUNCTION_OPEN,
                    ico: element?.FUNCTION_ICON,
                    redDot: element?.HAS_RED_POINT == '1',
                    configId: element?.FUNCTION_CONFIG_ID,
                    androidState: +element?.ANDROID_STATE, // android开关 0关 1开
                    iosState: +element?.IOS_STATE, // ios开关 0关 1开
                    h5State: +element?.H5_STATE, // h5开关 0关 1开
                    pcState: +element?.PC_STATE, // pc开关 0关 1开
                    showInReview: +element?.SHOW_IN_REVIEW // 审核模式显示 0不显示 1显示
                  };
                  // 审核模式下，SHOW_IN_REVIEW=1或IOS_STATE=1显示
                  if (IS_REVIEW) {
                    if (
                      functionItem.showInReview &&
                      devicePlate === 'ios' &&
                      functionItem.iosState
                    ) {
                      this.floatSdkParamList.push(functionItem);
                    }
                  }
                  // 非审核模式下:
                  // devicePlate=pc && H5_STATE=1，H5用户中心入口显示
                  // devicePlate=pc && PC_STATE=1，微端用户中心入口显示
                  // devicePlate=android && ANDROID_STATE=1，安卓用户中心入口显示
                  // devicePlate=ios && IOS_STATE=1，IOS用户中心入口显示
                  else {
                    if (
                      (devicePlate === 'pc' &&
                        functionItem.h5State &&
                        !IS_FROM_ELECTRON) ||
                      (devicePlate === 'pc' &&
                        functionItem.pcState &&
                        IS_FROM_ELECTRON) ||
                      (devicePlate === 'android' &&
                        functionItem.androidState) ||
                      (devicePlate === 'ios' && functionItem.iosState)
                    ) {
                      this.floatSdkParamList.push(functionItem);
                    }
                  }
                }
              });
              resolve();
            },
            res => {
              resolve();
            }
          );
        } else {
          resolve();
        }
      });
    },
    getNoticePopup() {
      return new Promise(resolve => {
        let serverId = globalConfig.getHrefParam('serverId');
        let newDevicePlate = globalConfig.getHrefParam('devicePlate');
        let isExe = globalConfig.getHrefParam('device') == 'exe';
        if (['pc', 'h5'].includes(devicePlate)) {
          if (this.isExeUserCenter || isExe) {
            newDevicePlate = 'pc';
          } else {
            newDevicePlate = 'h5';
          }
        }
        let language =
          globalConfig.getHrefParam('appLanguage') ||
          globalConfig.getHrefParam('language');
        this.$store
          .dispatch(GET_NOTICE_POPUP, {
            game_id: gameId,
            server_id: serverId,
            devicePlate: newDevicePlate,
            zone: language
          })
          .then(
            res => {
              if (res?.data?.has_announce) {
                this.openNoticePopup = true;
                this.noticeList = res?.data?.announcement || [];
              }
              resolve();
            },
            _err => {
              resolve();
            }
          );
      });
    },
    getModsPopup() {
      return new Promise(resolve => {
        let serverId = globalConfig.getHrefParam('serverId') || '';
        let roleName = globalConfig.getHrefParam('roleName') || '';
        let roleId = globalConfig.getHrefParam('roleId') || '';
        if (gameId && serverId && roleId && roleName) {
          this.$store.dispatch(GET_MODS_POPUP, { game_id: gameId }).then(
            res => {
              if (res?.data?.is_show_mod) {
                this.openModsPopup = true;
              }
              resolve();
            },
            _err => {
              resolve();
            }
          );
        } else {
          resolve();
        }
      });
    },
    sendShowNoticeRecord() {
      this.$store.dispatch(SEND_SHOW_NOTICE_RECORD, {
        announcement_id: this.noticeList.map(item => item.id).join(',')
      });
    },
    async gotoCustomLink(link, openType, configId, redDot) {
      if (openType === 'browser') {
        bridge.callSdkMethod(OPEN_BROSWER_METHOD, {
          url: link,
          loginDir: 1,
          appendParams: 1
        });
        if (redDot) {
          this.$store.dispatch(CLEAR_RED_POINT, configId);
        }
      } else {
        let searchArr = link.split('?');
        let realLink = searchArr[0];
        let queryArr = [
          'loginAccount',
          'devicePlate',
          'gameId',
          'serverId',
          'roleId',
          'roleName',
          'log',
          'appLanguage'
        ];
        let queryStr = queryArr
          .map(item => {
            let str = getHrefParam(item);
            if (item === 'roleName') {
              str = encodeURIComponent(str);
            }
            return `${item}=${str}`;
          })
          .join('&');
        if (searchArr.length > 1) {
          queryStr = `${queryStr}&${searchArr[1]}`;
        }
        if (redDot) {
          await this.$store.dispatch(CLEAR_RED_POINT, configId);
        }
        let href = `${realLink}?${queryStr}`;
        if (this.isExeUserCenter && !this.isOuterExeClient) {
          exesdk.openNewWindow(this.getExeWebsiteLoginSign(href));
        } else {
          window.location.href = href;
        }
      }
    },
    initLandscapeWidthFit() {
      document.querySelector('html').classList.add('width-100vw');
      document.querySelector('body').classList.add('width-100vw');
    },
    openMods() {
      const modsLink = `//gevents.${mainHost}/mods/indexm.html`;
      if (this.isH5) {
        window.location.href = getGlobalGetGotoLink({
          link: modsLink + window?.location?.search
        });
        return;
      }
      bridge.callSdkMethod(OPEN_WEBVIEW_METHOD, {
        url: getGlobalGetGotoLink({ link: modsLink }),
        loginDir: 1,
        appendParams: 1
      });
    },
    excOpenDmaPopup() {
      if (this.useDmaPopup) {
        this.dmaPopupState = true;
        return;
      }
      // 调第三方弹窗
      bridge.callSdkMethod('openAdmobConsent');
    },
    closeDmaPopup() {
      this.dmaPopupState = false;
    },
    saveDMASelect({ dmaType }) {
      const res = getJSON(PASSPORT_HOST + 'center/user_dma/save_dma_type', {
        gameId,
        dmaType
      });
      // localStorage.setItem(`last_dma_${gameId}`, `${dmaType}`);
      // globalConfig.setCookie(`last_dma_${gameId}`, `${dmaType}`);
      var date = new Date();
      date.setTime(date.getTime() + 30000 * 24 * 60 * 60 * 1000);
      var expires = '; expires=' + date.toUTCString();
      document.cookie =
        `last_dma_${gameId}` +
        '=' +
        `${dmaType}` +
        expires +
        `;domain=${mainHost};path=/`;

      return +res?.result === 1;
    },
    submitDma(selectValue) {
      this.closeDmaPopup();
      bridge.callSdkMethod('viewProtocolFinish', {
        consentMode: selectValue
      });
      this.$store.dispatch(UPDATE_DMA_SELECT, selectValue);
      // 上报DMA
      this.saveDMASelect({
        dmaType: selectValue
      });
    },
    popupRiskWindow() {
      this.$store.dispatch(SHOW_TIPS_MSG, {
        message: this.languages.riskTipContent,
        preWrap: true,
        textLeft: true,
        isScroll: true
      });
    },
    registerReloadWithToken() {
      window.reloadWithToken = () => {
        const hasExternalDomain =
          globalConfig.getHrefParam('hasExternalDomain') == 1;
        const passportToken = this.$store.state.account.passportToken;
        if (hasExternalDomain && !!passportToken) {
          exesdk.sendToIPC('reloadHtmlPage', {
            reloadWithToken: 1,
            passportToken
          });
        }
      };
    }
  },
  components: {
    Dialog,
    Tost,
    Header,
    ModsGuide,
    NoticePopup,
    DmaPopup
  }
};
</script>

<style lang="scss" scoped>
.pay-link,
.getrewatd-link {
  width: 100%;
}
</style>
